import { render, staticRenderFns } from "./module-box.vue?vue&type=template&id=1c57bc14&"
import script from "./module-box.vue?vue&type=script&lang=js&"
export * from "./module-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/gitlab-runner/builds/X4KPpxnC/0/feng.chen/site-cms/site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c57bc14')) {
      api.createRecord('1c57bc14', component.options)
    } else {
      api.reload('1c57bc14', component.options)
    }
    module.hot.accept("./module-box.vue?vue&type=template&id=1c57bc14&", function () {
      api.rerender('1c57bc14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/module-box.vue"
export default component.exports